import styled from 'styled-components';

const FormContainer = styled.div`
   margin: 0 auto;
   padding: 1rem 2rem;
   border-radius: 5px;
   display: flex;
   flex-direction: column;
   text-align: center;
   @media only screen and (max-width: 680px) {
      font-size: 1em;
   }

   @media only screen and (max-width: 400px) {
      padding: 0;
   }
`;

export default FormContainer;
